<template>
    <swiper :options="swiperOption" ref="mySwiper" class="my-slider">
        <!-- slides -->
        <swiper-slide class="one-slide">
            <img
                srcset="../assets/slider/slide-1.jpg, ../assets/slider/slide-1@2x.jpg 2x"
                src="../assets/slider/slide-1.jpg"
                class="block-progress__img"
            >
        </swiper-slide>
        <swiper-slide class="one-slide">
            <img
                srcset="../assets/slider/slide-2.jpg, ../assets/slider/slide-2@2x.jpg 2x"
                src="../assets/slider/slide-2.jpg"
                class="block-progress__img"
            >
        </swiper-slide>
        <swiper-slide class="one-slide">
            <img
                srcset="../assets/slider/slide-3.jpg, ../assets/slider/slide-3@2x.jpg 2x"
                src="../assets/slider/slide-3.jpg"
                class="block-progress__img"
            >
        </swiper-slide>
        <!-- Optional controls -->
        <div class="swiper-button-prev" slot="button-prev">
            <icon-slide-arrow />
        </div>
        <div class="swiper-button-next" slot="button-next">
            <icon-slide-arrow class="slider-arrow-right" />
        </div>
    </swiper>
</template>

<script>
export default {
    name: 'carrousel',
    data () {
        return {
            swiperOption: {
                effect: 'coverflow',
                grabCursor: true,
                centeredSlides: true,
                slidesPerView: 'auto',
                spaceBetween: 350,
                loop: true,
                autoHeight: true,
                slideToClickedSlide: true,
                coverflowEffect: {
                    rotate: 0,
                    stretch: 0,
                    depth: 200,
                    modifier: 2,
                    slideShadows: true
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                breakpoints: {
                    1140: {
                        spaceBetween: 300
                    },
                    960: {
                        spaceBetween: 200
                    },
                    780: {
                        slidesPerView: 1,
                        spaceBetween: 70
                    }
                }
            }
        }
    },
    computed: {
        swiper () {
            return this.$refs.mySwiper.swiper
        }
    },
    mounted () {
        this.swiper.slideTo(1, 1000, false)
    }
}
</script>

<style lang="stylus">
    div.my-slider {
        overflow initial
    }

    .slider-arrow-right {
        transform rotate(180deg)
    }

    div.swiper-button-prev,
    div.swiper-button-next {
        width 4.3rem
        height 4.3rem
        background none

        +layout-xs() {
            width 3rem
            height 3rem
        }
    }

    div.swiper-button-prev {
        left - 5.5rem

        +layout-xs() {
            top initial
            bottom 1rem
            left 0.5rem
        }
    }

    div.swiper-button-next {
        right - 5.5rem

        +layout-xs() {
            bottom 1rem
            top initial
            right .5rem
        }
    }

    .one-slide {
        +layout-xs() {
            object-fit contain

            img {
                width 100%
            }
        }
    }
</style>
